'use client';

import StoreCityIdSheet from '@/app/[locale]/[city]/components/location/store-city-id-sheet';
import { useStoreCitySheet } from '@/contexts/store-city-sheet-context';

export function StoreCityIdSheetManager() {
  const {
    showCityPopup,
    openCitySheet,
    closeCitySheet,
    address,
    setAddress,
    setNavigating,
    checkCityMismatch,
    enableCityMismatchCheck,
    setEnableCityMismatchCheck,
  } = useStoreCitySheet();

  const handleSetShowCityPopup = (show: boolean) => {
    if (show) {
      openCitySheet();
    } else {
      closeCitySheet();
    }
  };

  // Expose city mismatch utilities (for debugging or manual control)
  if (process.env.NODE_ENV === 'development') {
    (window as any).storeCityDebug = {
      checkCityMismatch,
      enableCityMismatchCheck,
      setEnableCityMismatchCheck,
    };
  }

  return (
    <StoreCityIdSheet
      showCityPopup={showCityPopup}
      setShowCityPopup={handleSetShowCityPopup}
      address={address}
      setAddress={setAddress}
      setNavigating={setNavigating}
    />
  );
}
